module.exports = __webpack_public_path__ + "static/media/inetcpl_1320.eab3c8a0.ico";